
export default {
  props: {
    name: { required: true },
    selected: {
      type: Boolean,
      default: false
    }
  },

  data() {

    return {
      isActive: false
    };

  },
  mounted() {
    this.isActive = this.selected;
  }
}
